
import { search } from '@/api'
import { AtomResult, ConceptResult } from '@/api/type'
import { defineComponent } from 'vue'
import BlankCard from '@/components/blankCard/index.vue'
import router from '@/router'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'

export default defineComponent({
  components: {
    BlankCard,
  },
  beforeRouteUpdate(to, from) {
    if (to.fullPath !== from.fullPath) {
      this.results = []
      this.page = 1
      this.conceptSearchLoad(to.params.query as string)
      localStorage.setItem('lastQuery', to.params.query as string)
    }
  },
  beforeRouteLeave() {
    window.removeEventListener('scroll', this.scrollBottom) //页面离开后销毁监听事件
  },
  data: () => ({
    page: 1 as number,
    count: 0 as number,
    results: [] as (ConceptResult | AtomResult)[],
    loading: true as boolean,
    finite: false as boolean,
    store: useStore(),
    route: useRoute(),
  }),
  created() {
    window.addEventListener('scroll', this.scrollBottom) //注册监听滚动条事件
  },

  methods: {
    initSeachName() {
      const conceptName = this.route.params.query as string
      ;(
        document.getElementsByClassName(
          'el-input__inner'
        )[1] as HTMLInputElement
      ).value = decodeURIComponent(conceptName)
    },

    goConceptDetail(ui: string) {
      router.push(
        `/conceptDetail/${ui}/${this.route.params.name}/${this.route.params.type}`
      )
    },

    async conceptSearchLoad(routerQuery: string | null = null) {
      this.loading = true
      const query = routerQuery || (this.$route.params.query as string)
      if (routerQuery) {
        this.finite = false
      }
      if (this.finite || !query) {
        this.loading = false
        return
      }

      if (this.loading) {
        const { count, searchResultItemList: results } = await search(
          query,
          this.page
        )
        this.loading = false

        results.forEach((item) => {
          item.highlightedLabel = item.highlightedLabel.replace(
            /#FF810D/gi,
            '#0ca1bd'
          )
          item.translatedLabel = item.highlightedLabel
            ? item.highlightedLabel
            : item.label
        })
        this.results = [...this.results, ...results]

        this.count = count

        if (count === 0 || this.results.length >= count) {
          this.finite = true
        }

        this.loading = false
        this.page += 1
      }
    },
    scrollBottom() {
      if (this.finite || this.loading || this.results.length === 0) return
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.conceptSearchLoad()
      }
    },
  },
  mounted() {
    this.conceptSearchLoad()
    this.initSeachName()
    localStorage.setItem('lastQuery', this.route.params.query as string)
  },
})
